import React, { useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import type { SnackbarKey } from 'notistack'
import { Button } from '@material-ui/core'
import type { CombinedState } from '@reduxjs/toolkit'

import { removeSnackbar, snackbarSelector } from './snackbar.reducer'
import { SnackBar } from './snackbar.types'
import { useSnackbarStyles } from './snackbar.styles'

export const Snackbar: React.FC = () => {
  const classes = useSnackbarStyles()
  const displayedNotifications = useRef<SnackbarKey[]>([])
  const dispatch = useDispatch()
  const notifications = useSelector<
    CombinedState<{ snackbar: SnackBar[] }>,
    SnackBar[]
  >(snackbarSelector)
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const storeDisplayed = (id: SnackbarKey) => {
    displayedNotifications.current = [...displayedNotifications.current, id]
  }

  const removeDisplayed = (id: SnackbarKey) => {
    displayedNotifications.current = [
      ...displayedNotifications.current.filter((key) => id !== key)
    ]
  }

  useEffect(() => {
    notifications.forEach(({ id, message, kind, isDismissed = false }) => {
      if (isDismissed) {
        closeSnackbar(id)
        return
      }

      if (displayedNotifications.current.includes(id)) return

      enqueueSnackbar(message, {
        key: id,
        variant: kind,
        onExited: (_, myKey: SnackbarKey) => {
          dispatch(removeSnackbar(myKey))
          removeDisplayed(myKey)
        },
        action: (key) => (
          <Button className={classes.button} onClick={() => closeSnackbar(key)}>
            dismiss me
          </Button>
        )
      })

      storeDisplayed(id)
    })
  }, [notifications, closeSnackbar, classes.button, enqueueSnackbar, dispatch])

  return null
}
